import * as axios from "axios";

export default class Api {
    static api_token;
    static api_url = "https://api.it-mood.de/api/"
    // static api_url = "http://localhost:3000/api/"
     static api_url_spring = "https://api2.it-mood.de/api/"
    //static api_url_spring = "http://localhost:8081/api"
    static headers = {};

    static instance = axios.create({
        baseURL: Api.api_url,
        timeout: 20000,
    });

    static instance_spring = axios.create({
        baseURL: Api.api_url_spring,
        timeout: 20000,
    });

    static getHeader = () => {
        return {
            "headers": {
                'Authorization': Api.api_token
            }
        }
    }

    static ebay_invoice = {
        invoice_csv(file) {
            let formData = new FormData();
            formData.append("file", file);
            return Api.instance_spring.post('ebay/invoiceCSV', formData, {
            headers: {
                'Authorization': Api.api_token,
                "Content-Type": "multipart/form-data",
                'Access-Control-Allow-Origin': '*',

            }}, Api.getHeader())},

        send_mail: () => Api.instance_spring.post('ebay/sendMail', Api.getHeader())
    };

    static ean = {
        getEANs: amount => Api.instance.post('ean', {amount}, Api.getHeader()),
        countEANs: () => Api.instance.get('ean', Api.getHeader()),
        addEAN: (eanList) => Api.instance.post('eanUpload',{eanList}, Api.getHeader())
    };

    static sku = {
        getSKUReplacements: () => Api.instance.get('skuAlias', Api.getHeader()),
        pushSKUReplacement: (sku) => Api.instance.post('skuAlias',{sku}, Api.getHeader()),
        deleteSKUReplacement: (_id) => Api.instance.delete('skuAlias/' + _id, Api.getHeader())
    };

    static materials = {
        getMaterials: () => Api.instance.get('materials', Api.getHeader()),
        updateMaterial: (document) => Api.instance.put('materials', {document}, Api.getHeader()),
        createMaterial: (document) => Api.instance.post('materials', {document}, Api.getHeader())

    };

    static images = {
         getImages: material => {
            return Api.instance.post('images', {material}, Api.getHeader())
         }
    };

    static history = {
        writeHistory: itemLines => {
            return Api.instance.post('history', {itemLines}, Api.getHeader())
        }
    }

    static upload_sizes = {
        getAllSizes: () => Api.instance.get('listingSize', Api.getHeader()),
        createNewSize: data => Api.instance.post('listingSize',data, Api.getHeader()),
        addNewSizesToExisting: data => Api.instance.post('listingSize/size',data, Api.getHeader()),
        updateSize: data => Api.instance.put('listingSize',data, Api.getHeader()),
        deleteSize: id => Api.instance.delete(`listingSize/${id}`, Api.getHeader())
    }


    static download = {
        downloadTemplateFile: () => Api.instance.get('download', {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf',
                'Authorization': Api.api_token
            }

        })
    }

    static shippingOptions = {
        getShippingOptions: () => Api.instance.get('shippingOptions', Api.getHeader())
    };
    static addresses = {

        getAddresses: () => {
            console.log(Api.getHeader())
            return  Api.instance.get('addresses', Api.getHeader())
        },

    };


    static init = (token) => {
        if (token) {
            Api.api_token = token;
        }

    };

    // static clear = () => {
    //     Api.api_token = undefined;
    // };
    static auth = {
        login: (params) => {
            const result = Api.instance.post(
                'auth/login',
                params,
                {
                    headers:
                        {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*'
                        }
                }
            )
            return result
        },

        verify: tokenParam => {
            return Api.instance.post('auth/verify', tokenParam, Api.getHeader())
        }
    }

    // static getMe() {
    //     return Api.instance.get('People/GetMe', {
    //         headers: {
    //             'Authorization': Api.api_token
    //         }
    //     })
    // }
    //
    // static getLanguages() {
    //     return Api.instance.get('Languages')
    // }
    //
    // static updateUser(newUser) {
    //     const id = newUser.id ? newUser.id : 0;
    //     return Api.instance.put(
    //         `People/PutPerson/${id}`,
    //         newUser,
    //         {
    //             headers: {
    //                 'Authorization': Api.api_token
    //             }
    //         })
    // }


}
